import { render, staticRenderFns } from "./assest.vue?vue&type=template&id=64a12b32"
import script from "./assest.vue?vue&type=script&lang=js"
export * from "./assest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports